import Platform from '@/platform'
import availableLanguages from '@/assets/data/availableLanguages.json'
import packageConfig from '../package.json'

//
// only pages should be imported and used here
// http://bradfrost.com/blog/post/atomic-web-design/
//

let routes = [
  {
    path: '/',
    name: 'Form',
    component: () => import(/* webpackChunkName: "page-service" */ './pages/FormPage')
  }
]

//
// System routes
//

if (!packageConfig.multilanguage) {
  // no multilanguage
  routes = routes.concat([
    {
      // matches /anyroute (if not found) and redirects it to /
      path: '*',
      redirect: '/'
    }
  ])
} else {
  //
  // multilanguage system
  // don't touch this :)
  //

  // create a regex capturing group like en|it|es|ru
  // based on availableLanguages
  let possibleLanguages = ''
  Object.keys(availableLanguages).forEach((lang) => {
    possibleLanguages += lang + '|'
  })
  possibleLanguages = possibleLanguages.substring(0, possibleLanguages.lastIndexOf('|'))

  // determine user browser language
  let userLanguage
  if (!Platform.prerenderer) {
    userLanguage = (window.navigator.languages ? window.navigator.languages[0] : null) || window.navigator.userLanguage || window.navigator.language || 'en'
    // strip down '-US' part (as in 'en-US' or similar) if present
    userLanguage = userLanguage.split('-')[0]
  } else {
    userLanguage = 'en'
  }

  let getValidLanguage = () => {
    // if it exist, set user language as default
    if (availableLanguages[userLanguage]) {
      return userLanguage
    }
    // set first language as default
    return Object.keys(availableLanguages)[0]
  }

  routes.forEach(route => {
    let oldPath = route.path
    // modify routes to require a valid language before it
    route.path = `/:language(${possibleLanguages})${route.path}`

    if (Platform.prerenderer) {
      // create duplcate routes for pre-renderer with no language
      // it needs them in order to avoid redirection from / to /en (for example)

      // TODO: Deep clone of nested routes?
      let dup = {}
      Object.keys(route).forEach(key => {
        dup[key] = route[key]
      })
      dup.name = route.name + '-prerenderer'
      dup.path = oldPath
      routes.push(dup)
    }
  })
  // append utility routes for redirection
  routes = routes.concat([
    {
      // matches /validlanguage/invalidroute and redirects it to /validlanguage
      path: `/:language(${possibleLanguages})/*`,
      redirect: to => {
        return `/${getValidLanguage()}`
      }
    },
    {
      // matches /invalidlanguage(2 chars)/anyroute and redirects it to /validlanguage/anyroute
      path: `/:language(\\w{2,2}\\b)/*`,
      redirect: to => {
        return `/${getValidLanguage()}/${to.params[0]}`
      }
    },
    {
      // matches /anyroute (if not found) and redirects it to /validlanguage/anyroute
      path: '*',
      redirect: to => {
        return `/${getValidLanguage()}${to.path}`
      }
    }
  ])
}

export default routes
